import * as React from "react"
import { useEffect } from "react"
import { batch } from "@preact/signals-react"
import { Skeleton } from "@mui/material"

import { ADMIN_ROUTES, HOME_ROUTES } from "@constants"
import { isLoadingCommonFilters } from "@signals"
import { useAdminNewListedSubmits } from "./@hooks"
import { adminNewListedDetails, adminNewListedShowTable, adminNewListedTableData } from "./@signals"
import AdminNewListedContent from "./Content"
import AdminNewListedDetailsDrawer from "./Details"
import AdminNewListedFilters from "./Filters"
import AdminNewListedFormDrawer from "./Form"
import PageWrapper from "../../@PageWrapper"


export default function AdminNewListedPage() {
	const { adminNewListedIsEmpty, handleSubmitFilters } = useAdminNewListedSubmits()

	useEffect(() => {
		return () => batch(() => {
			adminNewListedTableData.value = []
			adminNewListedDetails.value = {}
		})
	}, [])

	return <PageWrapper
		head={`${ADMIN_ROUTES.NEW_LISTED_TITLE}`}
		title={ADMIN_ROUTES.NEW_LISTED_TITLE}
		subtitle={ADMIN_ROUTES.NEW_LISTED_SUBTITLE}
		isEmpty={adminNewListedIsEmpty.value}
		filters={<AdminNewListedFilters onSubmit={handleSubmitFilters} />}
	>
		{ !!isLoadingCommonFilters.value && <Skeleton variant="rectangular" height={700} /> }

		{!!adminNewListedShowTable.value && <>
			<AdminNewListedContent/>
		</>}

		<AdminNewListedDetailsDrawer />
		<AdminNewListedFormDrawer />
	</PageWrapper>
}